<template>

  <div class="comment-add">
    <!-- 标题 -->
    <el-dialog :title="title" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"  :close-on-press-escape="false">
      <el-form size="small" :model="form" ref="form">


        <!-- <el-form-item label="关联用户ID" :label-width="formLabelWidth">
          <el-input type="text" v-model="form.user_id" autocomplete="off">
          <el-button slot="append" type="primary" icon="el-icon-user-solid" @click="openUserDialog()">所属用户</el-button>
          </el-input>
        </el-form-item> -->


        <el-form-item label="供应商名称" prop="company_name" :label-width="formLabelWidth" :rules="[{ required: true, message: '请输入供应商名称' }]">
          <el-input type="text" v-model="form.company_name" autocomplete="off"></el-input>
        </el-form-item>

       <!-- <el-form-item label="联系人" prop="name" :label-width="formLabelWidth" :rules="[{ required: true, message: '请输入联系人' }]">
          <el-input type="text" v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="mobile" :label-width="formLabelWidth" :rules="[{ required: true, message: '请输入联系方式' }]">
          <el-input type="text" v-model="form.mobile" autocomplete="off"></el-input>
        </el-form-item> -->

        <el-form-item label="是否启用" :label-width="formLabelWidth">
          <div>
            <el-radio v-model="form.status" label="1">是</el-radio>
            <el-radio v-model="form.status" label="0">否</el-radio>
          </div>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button  type="primary" @click="save" :loading="loading">确 定</el-button>
      </div>

    </el-dialog>
    <!--用户选择-->
    <GetUser :is_open="open_user" @close="closeUserDialog"></GetUser>
  </div>
</template>

<script>
  import SupplierApi from '@/api/supplier.js';
  import GetUser from '@/components/user/GetUser.vue';
  export default {
    components: {
      GetUser
    },
    data() {
      return {
        // 类型
        type:'add',  // add:添加  edit:编辑 dateil:详情
        title:'添加',

        //需要提交的表单
        form: {},
        user: {},
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,//是否展示
        //加载
        loading: false,
        open_user: false,
      };
    },
    props: ['open_add', 'addform'],//open_add 是否展示
    created() {
      //数据赋值
      this.type = this.addform.type;

      //类型
      if(this.type == 'edit' || this.type == 'dateil'){

        if(this.type == 'edit' ){
          this.title = '编辑';
        }else{
          this.title = '详情';
        }
        //赋值
        this.form = this.addform.model;
        if(this.form.status==1){
          this.form.status = '1';
        } else {
          this.form.status = '0';
        }
      }

      //是否展示
      this.dialogVisible = this.open_add;
    },
    methods: {
      /*保存*/
      save() {
        let self = this;
        let params = self.form;
        self.$refs.form.validate(valid => {
          if(valid){
              self.loading = true;
              if(self.type == 'add'){
                SupplierApi.add(params).then(data => {
                  self.loading = false;
                  self.$message({
                    message: '添加成功',
                    type: 'success'
                  });
                  self.dialogFormVisible(true);
                }).catch(error => {
                  self.loading = false;
                });
              }else if(self.type == 'edit'){

                SupplierApi.edit(params).then(data => {
                  self.loading = false;
                  self.$message({
                    message: '添加成功',
                    type: 'success'
                  });
                  self.dialogFormVisible(true);
                }).catch(error => {
                  self.loading = false;
                });
              }
          }

        })

      },

      /*打开用户弹窗*/
      openUserDialog() {
        this.open_user = true;
      },
      /*关闭用户弹窗*/
      closeUserDialog(e) {
        if (e.type != 'error') {
          this.user = e.params[0];
          this.form.user_id = e.params[0].user_id;
        }
        this.open_user = false;
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
    }
  };
</script>

<style>
 .img {
    margin-top: 10px;
    display: flex;
  }
  .img img {
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/supplier/supplier/dialog/Op.vue